import axios from 'core/network/interceptor';
import { ApproveDocumentUrl, DeleteDocumentUrl, GetDocumentsUrl, PostDocumentUrl, RejectDocumentUrl, RetryDocumentOcrUrl } from './constants';

const GetDocumentsRequest = async (tempWorkerId: number) => {
    const response = await axios.get(GetDocumentsUrl(tempWorkerId));

    return response.data;
};

interface upsertDocumentsEntryVariables {
    tempWorkerId: number;
    documentId?: number;
    key: string;
    name?: string;
    file?: any;
}

const UpsertDocumentsRequest = async ({tempWorkerId, documentId, key, name, file}: upsertDocumentsEntryVariables) : Promise<any> => {
    const formData = new FormData();
    formData.append('key', key);
    if (file !== undefined) formData.append('file', file);
    if (name !== undefined) formData.append('name', name);
    if (documentId !== undefined) formData.append('id', `${documentId}`);

    const response = await axios.post(PostDocumentUrl(tempWorkerId), formData);
    return response.data;
};

interface deleteDocumentsEntryVariables {
    tempWorkerId: number;
    id: number;
    file_id?: number;
}

const DeleteDocumentsRequest = async ({tempWorkerId, id, file_id}: deleteDocumentsEntryVariables) : Promise<any> => {
    const data : any = {};
    if (file_id !== undefined) data['file_id'] = file_id;

    const response = await axios.delete(DeleteDocumentUrl(tempWorkerId, id), {data});

    return response.data;
};

interface approveDocumentEntryVariables {
  tempWorkerId: number;
  documentId: number;
  ocrData: any;
}

const ApproveDocumentRequest = async ({tempWorkerId, documentId, ocrData}: approveDocumentEntryVariables) : Promise<any> => {
  const response = await axios.post(ApproveDocumentUrl(tempWorkerId, documentId), {ocr_data: ocrData});
    return response.data;
};

interface rejectDocumentEntryVariables {
  tempWorkerId: number;
  documentId: number;
  rejectionReason: string;
}

const RejectDocumentRequest = async ({tempWorkerId, documentId, rejectionReason}: rejectDocumentEntryVariables) : Promise<any> => {
    const response = await axios.post(RejectDocumentUrl(tempWorkerId, documentId), {rejection_reason: rejectionReason});
    return response.data;
};

interface retryDocumentOcrEntryVariables {
  tempWorkerId: number;
  documentId: number;
}

const RetryDocumentOcrRequest = async ({tempWorkerId, documentId}: retryDocumentOcrEntryVariables) : Promise<any> => {
  const response = await axios.post(RetryDocumentOcrUrl(tempWorkerId, documentId));
  return response.data;
};

export { GetDocumentsRequest, UpsertDocumentsRequest, DeleteDocumentsRequest, ApproveDocumentRequest, RejectDocumentRequest, RetryDocumentOcrRequest }
